import { render, staticRenderFns } from "./estateList.vue?vue&type=template&id=86f1aad2&scoped=true"
import script from "./estateList.vue?vue&type=script&lang=js"
export * from "./estateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f1aad2",
  null
  
)

export default component.exports